import React, {Component} from 'react';

import NextStep from '../elements/NextStep';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

/**
 * Import assets
 */
import ListButton from '../elements/ListButton';
import PolicyChoiceLaag from '../elements/PolicyChoiceLaag';
import { getPolicyChoiceFeedback, checkRead } from '../../helpers/feedbackHelpers';
import { calculateSavingsAndLoans, calculateBudgetBASIC } from '../../helpers/calculationsHelper';
import { getIcon, getTitle, groupByProblem } from '../../helpers/policyChoiceHelper';
import Scrollbar from "react-scrollbars-custom";


class Beleidskeuzes extends Component {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };


  componentDidMount() {
  }


  render() {
    const { gameState, feedback, policyChoice, gameStateInput } = this.props;
    const {prevRoundSum} = gameState;
    if(!prevRoundSum) return null;

    // Filter policy choices to show 1 per number
    const filteredPolicyChoices = groupByProblem(policyChoice);

    const globas = calculateBudgetBASIC(
      gameState,
      gameStateInput.myState.policyChoices,
      gameStateInput.myState.ministerieGlobaVerdeling,
      calculateSavingsAndLoans(gameStateInput),
      policyChoice
    );

    return (
      <div className={"darkBckg"}>
        <Scrollbar className="custom-height" noScrollX style={ {width: '100%', height: '100%', minHeight: 300} } >
          <div className='container policy-ministry-container'>
            <div className={'low-policy'}>
              {gameState.currentStep === 3 ? filteredPolicyChoices.map((pc, i) => (
                <PolicyChoiceLaag
                  key={i}
                  problem={pc}
                  spendableGlobas={globas}
                  mainView={true}
                  setShow={parseInt(this.props.match.params.beleidskeuze, 10) === i}
                  history={this.props.history}
                />
                )) : (
                <div className="feedback-list">
                  {getPolicyChoiceFeedback(feedback.prevRoundFeedbackData).map((feedback, i) => {
                    return (
                      <div className={'feedback-container-low'} key={i}>
                        <ListButton
                          feedbackCount={checkRead(feedback) ? 0 : 1}
                          bgColor={(Math.sign(feedback.puntenscore) ? 'green' : 'red')}
                          title={getTitle(feedback, gameState.language)}
                          arrow={true}
                          feedback={true}
                          thumbnail={getIcon(feedback)}
                          points={feedback.puntenscore}
                          onClick={() => {
                            this.props.history.push(`/beleidskeuzes/beleidskeuze/${feedback.omschrijving}`);
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>

        </Scrollbar>
        <NextStep/>
      </div>
    );
  }
}

export default connect(({gameState, feedback, policyChoice, gameStateInput, project}) => ({gameState, feedback, policyChoice, gameStateInput, project}))(Beleidskeuzes);



// WEBPACK FOOTER //
// ./src/components/desktop/Beleidskeuzes.js